import {SearchContactType} from "../interface";
import {useQuery} from "@tanstack/react-query";
import {readContactDetailApi} from "../../../../api/correspondent/contractApi";

type Props = {
    searchDetailOption: SearchContactType;
    isCreate: boolean;
};

/**
 * 연락처 detail hook
 */
export const useReadContactDetail = ({
                                         searchDetailOption,
                                         isCreate,
                                     }: Props) => {
    const {data} = useQuery({
        queryKey: ["readContactDetail", searchDetailOption],
        queryFn: async () => await readContactDetailApi(searchDetailOption),
        // staleTime: 6000 * 10,
        select: (res) => res?.result,
        enabled: !isCreate,
    });
    return {data};
};
